<div class="ecard-shell">
	@if (loading()) {
	<div class="loading">
		<ui-loading type="component" size="medium" />
	</div>
	} @else {

	<div [class]="'header' + (isMember() ? ' is-member' : ' is-not-member')">
		<img [src]="clubIcon()" alt="Logo" class="logo" />
		<h1 class="title">{{ clubName() }}</h1>
	</div>

	<!-- ----- Avatar + identité, en colonne centrée -->
	<div class="content">
		<div class="identity">
			@if (photo()) {
			<img [src]="'data:image/png;base64,' + photo()" alt="Photo de profil" class="photo" />
			} @else {
			<div class="photo photo--initials">{{ initials() }}</div>
			}
			<h1 class="name">{{ cardData()?.prenom }} {{ cardData()?.nom }}</h1>
			<ui-badge [label]="isMember() ? 'Membre' : 'Non membre'" [severity]="isMember() ? 'success' : 'danger'" size="small" />
		</div>

		<!-- ----- Email / Tel -->
		<div class="contact">
			<div class="info">
				<i class="pi pi-envelope"></i>
				<p class="text-sm text-gray-600">{{ cardData()?.email }}</p>
			</div>
			<div class="info">
				<i class="pi pi-phone"></i>
				<p class="text-sm text-gray-600">{{ cardData()?.tel1 }}</p>
			</div>
		</div>
	</div>

	<!-- ----- Bouton retour -->
	<div class="footer">
		<ui-button label="Retour" icon="pi pi-arrow-left" (onClick)="goBack()" severity="secondary" [fluid]="true" size="small" />
	</div>
	}
</div>
